import { useState } from 'react'
import { ContentModal } from 'components/organisms/modals/content-modal'
import { PieImage } from 'components/common'
import { EventsPageGetEventDetailsQueryType } from 'pages/Events/events.type'

interface WaitlistSuccessModalProps {
	open: boolean
	setOpen: (open: boolean) => void
	event: EventsPageGetEventDetailsQueryType
}

export function WaitlistSuccessModal({ open, setOpen, event }: WaitlistSuccessModalProps) {
	return (
		<ContentModal open={open} setOpen={setOpen} isModal>
			<div className="relative flex flex-col items-center space-y-5">
				<div className="max-w-[304px]">
					<div>
						<h3 className="text-xl font-bold flex justify-center items-center gap-2">
							You've been added to the waitlist for {event.displayName}
						</h3>
					</div>
					<div className="flex justify-center items-center py-8 relative">
						<PieImage
							className="w-[200px] h-auto rounded-xl overflow-hidden flex-shrink-0"
							images={[event?.avatarUrl]}
						/>
					</div>
					<div className="text-md">
						<div className="flex flex-col gap-6">
							We will notify you when more tickets are available for this event.
						</div>
					</div>
				</div>
			</div>
		</ContentModal>
	)
}

// ---------------------------------------------------------------------------
// Modal Manager integration
// ---------------------------------------------------------------------------

export interface WaitlistSuccessModalManagedProps {
	event: EventsPageGetEventDetailsQueryType
}

declare module 'components/organisms/modals/modal-registry' {
	interface ModalRegistry {
		'waitlist-success': WaitlistSuccessModalManagedProps
	}
}

export function ManagedWaitlistSuccessModal({
	onClose,
	...rest
}: WaitlistSuccessModalManagedProps & { onClose: () => void }) {
	const [open, setOpen] = useState(true)

	const handleClose = () => {
		setOpen(false)
		setTimeout(onClose, 200)
	}

	return (
		<WaitlistSuccessModal
			open={open}
			setOpen={(v: boolean) => { if (!v) handleClose() }}
			{...rest}
		/>
	)
}
